// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3H_g-","location":"Header_location__3Ggts"};